import { useQuery } from '@tanstack/react-query';

import fetchOrgsByNameOrDomain from '../api/fetchOrgsByNameOrDomain';

export default function useGetOrgsByNameOrDomain({ domains = [], name = '' }) {
  return useQuery({
    queryKey: ['getOrganizationsByDomainOrName', domains, name],
    queryFn: () => fetchOrgsByNameOrDomain({ domains, name }),
    enabled: !!(domains?.length || name.length),
  });
}
